// Web Component: StoreStock
// Gestisce la visualizzazione degli stock nei negozi fisici e la consegna a domicilio tramite Vue.
// Attributi richiesti: data-sku, data-zip, data-province
// Dipendenze: Utils, axios, Vue, presenza di component e dati shippingData
// Limiti: richiede struttura HTML compatibile e dati JSON corretti
// Utilizzato nelle pagine prodotto per mostrare disponibilità nei negozi
class StoreStock extends HTMLElement {
  static UNIFIED = 'XY'; // codice dello store unified
  static URLSTORES = `${Utils.API_URL}/api/fidelity/shops`;
  static URLSTOCK = `${Utils.API_URL}/api/shop/${Shopify.shop}/product-stocks-by-sku-codes`;
  static MAP_API = 'AIzaSyDzJfY1o0dk-bSGQPKFiur1uBzt2TjVYRE';

  connectedCallback() {
    const element = this;
    const shippingData = JSON.parse(this.querySelector('component').textContent);
    console.log('StoreStock shippingData', shippingData);

    const app = Vue.createApp({
      delimiters: ['${', '}'],
      data() {
        return {
          loading: true, // stato di caricamento
          stocks: [], // lista degli stock da onestock
          stores: [], // lista dei negozi
          storesWithStock: [], // lista dei negozi mergiata con gli stock
          unified: null, // store unified, per la consegna a domicilio
          error: null, // messaggio di errore
          shippingData: shippingData, // elenco di consegne da mostrare nel consegna a domicilio
          favouriteStore: null, // negozio scelto dall'utente
          zip: element.dataset.zip || null, // CAP inserito dall'utente
          province: element.dataset.province || null, // provincia trovata con api google
          geolocalizationLoading: false, // stato di caricamento della geolocalizzazione
          noStoreForProvince: false, // stato se non ci sono negozi per la provincia
        }
      },
      methods: {

        // ottiene gli stocks da onestock
        getStocks() {
          this.loading = true;
          axios({
            url: StoreStock.URLSTOCK,
            method: 'post',
            data: JSON.stringify(element.dataset.sku.split(',')),
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            this.stocks = response.data;
            if(!this.stocks || this.stocks.length === 0) {
              this.error = 'No stocks found';
              return;
            }
            this.mergeStoresWithStocks();
          }).catch((error) => {
            this.error = error.message;
          }).finally(() => {
            this.loading = false;
          });
        },

        // riconosce lo store unified, che è quello per la consegna a domicilio
        getUnified() {
          if(this.unified) return;
          this.unified = this.stocks.find(s => s.storeCode === StoreStock.UNIFIED);
          if(!this.unified) {
            this.error = 'No unified store found';
            return;
          }
          this.unified.deliveryOptions = this.shippingData.filter(d => {
            return d.country.toUpperCase() == element.dataset.country && d.min <= d.product_price && d.max >= d.product_price
          }).sort((a, b) => {
            if (a.name < b.name) return 1;
            if (a.name > b.name) return -1;
            return 0;
          }).map(d => {
            return {...d, formattedPrice: Utils.money(d.price)}
          });
          if(this.unified.deliveryOptions.length === 0) {
            this.error = 'No delivery options found for unified store';
            return;
          }
          console.log('StoreStock unified', this.unified);
        },

        // usata a frontend per calcolare la data di consegna
        calcDeliveryDate(days) {
          let date = new Date();
          let added = 0;
          while (added < days) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
              added++;
            }
          }
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          return `${day}/${month}`;
        },

        // ottiene i negozi da onestock
        getStores() {
          if(this.stores.length > 0) return;
          this.stores = JSON.parse(sessionStorage.getItem('stores'));
          console.log('StoreStock stores from session', this.stores);
          if(this.stores && this.stores.length > 0) {
            this.mergeStoresWithStocks();
            return;
          }
          this.loading = true;

          axios({
            url: StoreStock.URLSTORES,
            method: 'get',
            withCredentials: true
          })
          .then((response) => {
            this.stores = response.data;
            sessionStorage.setItem('stores', JSON.stringify(this.stores));
            console.log('StoreStock stores', this.stores);
            this.mergeStoresWithStocks();
          }).catch((error) => {
            this.error = error.message;
          }).finally(() => {
            this.loading = false;
          });
        },

        // merge tra negozi e stock
        mergeStoresWithStocks() {
          if(this.stores.length <= 0) {
            this.loading = true;
            this.getStores();
            return;
          }
          console.log('StoreStock merging stores and stocks', this.stores, this.stocks);
          if(this.stocks.length <= 0) {
            this.loading = true;
            this.getStocks();
            return;
          }
          this.loading = false;
          this.storesWithStock = this.stores.map(store => {
            const stock = this.stocks.find(s => s.storeCode === store.shop_id?.value);
            return {...store, stock: stock || {quantity: 0, storeCode: store.shop_id?.value, productSku: element.dataset.sku}};
          });
          console.log('StoreStock storesWithStock', this.storesWithStock);
          this.getUnified();
          this.getFavouriteStore();
        },

        // click sul negozio preferito
        favStoreClicked() {
          if(this.favouriteStore){
            this.openListModal();
            return;
          }

          if(this.noStoreForProvince) {
            this.openListModal();
            return;
          }

          this.noStoreForProvince = false;
          this.province = element.dataset.province || localStorage.getItem('province');
          this.zip = element.dataset.zip || localStorage.getItem('zip');
          console.log('StoreStock favStoreClicked', this.province, this.zip);
          if(this.province) {
            this.getFavouriteStore();
            return;
          }
          
          if(!navigator.geolocation) {
            this.openZipModal();
            return;
          }
          
          console.log('StoreStock requesting geolocation');
          this.loading = true;
          navigator.geolocation.getCurrentPosition(position => {
            console.log('StoreStock geolocation', position);
            const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            this.geocode({ 'latLng': latlng });
          }, error => {
            console.log('StoreStock geolocation error', error);
            this.openZipModal();
          });
        },

        // ottiene il negozio preferito
        getFavouriteStore(){
          if(this.favouriteStore) return;
          const store = localStorage.getItem('favourite_shop');
          if(store !== undefined && store !== null && store !== 'undefined') {
            console.log('StoreStock favouriteStore from localStorage id', store);
            const fav = this.storeList.find(s => s.shop_id?.value === store);
            this.favouriteStore = fav || null;
            console.log('StoreStock favouriteStore from localStorage', this.favouriteStore);
            if(!this.favouriteStore){
              localStorage.removeItem('favourite_shop');
              this.getFavouriteStore();
            }
            return;
          }
          if(!this.province || !this.zip) {
            return;
          }

          this.favouriteStore = this.storeList.find(s => s.address.zip === this.zip);
          if(!this.favouriteStore) {
            this.favouriteStore = this.storeList.find(s => s.address.provinceCode === this.province);
          }
          console.log('StoreStock favouriteStore by province/zip', this.favouriteStore);

          if(!this.favouriteStore) {
            this.noStoreForProvince = true;
            return;
          }

          this.noStoreForProvince = false;
          localStorage.setItem('favourite_shop', this.favouriteStore.shop_id?.value);
        },

        // apre il modal per inserire il CAP
        openZipModal() {
          this.loading = false;
          setTimeout(() => {
            const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('store-province'));
            offcanvas.show();
          });
        },

        // apre il modal per scegliere il negozio
        openListModal() {
          const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('store-finder'));
          const productData = JSON.parse(document.querySelector('#product-json')?.innerText).product;
          const variantData = JSON.parse(document.querySelector("#product-json")?.innerText).variant;
          Shopify.analytics.publish(`pdp:interaction`, { productTitle: productData.title, variantSKU: variantData.sku, action: 'Store Stock' });
          offcanvas.show();
        },

        // localizza l'indirizzo
        geocode(data) {
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode(data, (results, status) => {
            this.loading = false;
            if(status !== google.maps.GeocoderStatus.OK) {
              this.openZipModal();
              return;
            }
            this.province = results[0].address_components.find(component => {
              return component.types.includes('administrative_area_level_2');
            });
            this.zip = results[0].address_components.find(component => {
              return component.types.includes('postal_code');
            });
            this.province = this.province?.short_name;
            this.zip = this.zip?.short_name;
            if(!this.province || !this.zip) {
              this.openZipModal();
              return;
            }
            localStorage.setItem('province', this.province);
            localStorage.setItem('zip', this.zip);
            this.getFavouriteStore();
            console.log('StoreStock geocode', this.province, this.zip);
          });
        },

        // seleziona il negozio dall'elenco
        selectStore(store) {
          this.favouriteStore = store;
          localStorage.setItem('favourite_shop', store.shop_id?.value);
          console.log('StoreStock selectStore', this.favouriteStore);
        },

        // l'utente ha inserito il CAP
        zipSelected() {
          if(!this.zip) return;
          this.geocode({ 'address': this.zip });
        }
      },
      computed: {
        storeList() {
          return this.storesWithStock.filter(store => store.shop_id.value != StoreStock.UNIFIED).map(store => {
            return {
              ...store,
              formattedAddress: `${store.address.address1}<br>${store.address.zip} ${store.address.city} (${store.address.provinceCode})`
            }
          });
        }
      },
      mounted () {
        this.mergeStoresWithStocks();
        console.log('StoreStock mounted', this.shippingData);
      }
    });
    app.config.compilerOptions.isCustomElement = (tag) => {
      return tag.includes('-');
    };
    app.mount(this);
  }
}
if(!customElements.get('store-stock')) {
  customElements.define('store-stock', StoreStock);
}